import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import CodeEditor from 'components/CodeEditor';

import styles from './styles';

const useStyles = createUseStyles(styles, 'Code');

function Code({
    className,
    isReadOnly = false,
    language = 'javascript',
    onBlur,
    onChange,
    snippets,
    theme = 'vs-dark',
    value,
    ...props
}) {
    const classes = useStyles();

    const handleChange = useCallback(
        (newValue) => {
            onChange?.(newValue);
        },
        [onChange],
    );

    const handleBlur = useCallback(() => {
        onBlur?.(value);
    }, [onBlur, value]);

    return (
        <div className={classes.editorWrapper} onBlur={handleBlur}>
            <CodeEditor
                className={className}
                language={language}
                onChange={handleChange}
                readOnly={isReadOnly}
                snippets={snippets}
                theme={theme}
                value={value}
                {...props}
            />
        </div>
    );
}

Code.propTypes = {
    className: PropTypes.string,
    isReadOnly: PropTypes.bool,
    language: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    snippets: PropTypes.object,
    theme: PropTypes.string,
    value: PropTypes.string,
};

export default memo(Code);
